import React, { PureComponent } from 'react';
import { map, cloneDeep, remove, uniqBy, isEmpty, get, isFunction } from 'lodash';
import { Tag, Popconfirm, Button, message, Spin } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ExportJsonExcel from 'js-export-excel';
import { services } from '@comall-backend-builder/core';
import { localStorage } from '@comall-backend-builder/core/lib/services';
import { ShowProductsUploadButtonSpu } from '../../../../components';
import { ProductSelectModal } from './ProductSelectModal';
const api = services.api;

export class ShowProducts extends PureComponent<any> {
    removeProduct = (item) => {
        const { onChange, value } = this.props;
        let newValue = cloneDeep(value);
        remove(newValue, { spuId: item.spuId });
        onChange(newValue);
    };

    clearAll = () => {
        const { onChange } = this.props;
        onChange([]);
    };

    renderProducts(products) {
        const isDragDropDisabled = products.length === 1;
        const { loading } = this.state;

        if (loading) {
            return (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <Spin size="large" tip="加载中..." />
                </div>
            );
        }

        return (
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable isDropDisabled={isDragDropDisabled} droppableId="product-list">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            {map(products, (item, index) =>
                                this.renderProduct(item, index, isDragDropDisabled)
                            )}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }

    componentDidMount(): void {
        const { value, componentId } = this.props;
        const spus = value.map((item: any) => item.spu);
        const spuDicStore: any = localStorage.get('spu-componentIds') || {};
        if (spuDicStore && spuDicStore[componentId]) {
            this.setState({ spuDic: spuDicStore[componentId], loading: false });
            return;
        }
        this.setState({ loading: true });
        api.get({ page: 1, per_page: 1000, spus: spus }, { apiPath: `/products/search/find_spu` })
            .then((res: any) => {
                if (res.result?.length) {
                    const spuDic = res.result.reduce((prev, cur) => {
                        prev[cur.spu] = cur.name;
                        return prev;
                    }, {});
                    localStorage.set('spu-componentIds', { ...spuDicStore, [componentId]: spuDic });
                    this.setState({ spuDic, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    handleExport = (value: any) => {
        if (value?.length) {
            const exportData = value.map((item, index) => ({
                code: index + 1,
                spu: item?.spu,
                name: item?.name,
            }));
            // 直接导出文件
            let option: any = {}; //option代表的就是excel文件
            option.fileName = '商品导出数据'; //excel文件名称
            option.datas = [
                {
                    sheetData: exportData, //excel文件中的数据源
                    sheetName: 'Sheet1', //excel文件中sheet页名称
                    sheetFilter: ['spu', 'name'], //excel文件中需显示的列数据
                    sheetHeader: ['SPU编号', '商品名称'], //excel文件中每列的表头名称
                    columnWidths: ['12', '18'],
                },
            ];
            let toExcel = new ExportJsonExcel(option); //生成excel文件
            toExcel.saveExcel(); //下载excel文件
            message.success('导出成功！');
        } else {
            message.warning('请先选择商品！');
        }
    };

    renderProduct = (item, index, isDragDisabled) => {
        const removeProduct = this.removeProduct;
        const { spuDic } = this.state;
        const name = (spuDic && spuDic[item.spu]) || item.name;
        return (
            <Draggable
                isDragDisabled={isDragDisabled}
                draggableId={'product-' + index}
                key={index}
                index={index}
            >
                {(provided) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                        >
                            <Tag
                                key={item.spuId}
                                closable
                                onClose={() => removeProduct(item)}
                                className="product-i"
                            >
                                <div style={{ height: 40, display: 'inline-block' }}>
                                    {item.spu}；{name}
                                </div>
                            </Tag>
                        </div>
                    );
                }}
            </Draggable>
        );
    };
    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
        const { value, onChange } = this.props;
        let newValue = cloneDeep(value);
        const startIndex = result.source.index;
        const endIndex = result.destination.index;
        const [removed] = newValue.splice(startIndex, 1);
        newValue.splice(endIndex, 0, removed);

        onChange(cloneDeep(newValue));
    };

    toggleUploadModalFun = (data) => {
        this.setState({
            showUploadModal: !this.state.showUploadModal,
        });
        if (data) {
            console.log(data, '+++data+++');
            const { onChange, value } = this.props;
            const spuData = uniqBy(value.concat(data), 'spuId');
            const newValue = spuData.filter((item: any) => item.spuId);
            onChange(newValue);
        }
    };

    toggleProductSelectModal = () => {
        this.setState({
            showProductSelectModal: !this.state.showProductSelectModal,
        });
    };

    handleProductSelect = (selectedProducts: any) => {
        const { onChange, value } = this.props;
        const selectedProductsIds = selectedProducts.map((item: any) => item.spuId);
        const valueFilter = value.filter((item: any) => selectedProductsIds.includes(item.spuId));
        onChange(uniqBy(valueFilter.concat(selectedProducts), 'spuId'));
        this.setState({ showProductSelectModal: false });
        message.success(`已选择 ${selectedProducts.length} 个商品`);
    };
    state = {
        showUploadModal: false,
        showProductSelectModal: false,
        spuDic: {},
        loading: true,
    };
    render() {
        const { value } = this.props;
        const hasProducts = !isEmpty(value);
        let { showUploadModal } = this.state;
        let uploadPropsObj = {
            showUploadModal: showUploadModal,
            toggleUploadModal: this.toggleUploadModalFun,
            type: '',
        };
        return (
            <div className="products-show">
                {this.renderProducts(value)}
                {hasProducts && (
                    <Popconfirm
                        title="确定清空商品吗?"
                        onConfirm={this.clearAll}
                        okText="确定"
                        cancelText="取消"
                    >
                        <Button className="show-action" type={'link'}>
                            清空商品
                        </Button>
                    </Popconfirm>
                )}
                <Button type={'link'} onClick={this.toggleProductSelectModal}>
                    选择商品
                </Button>
                <Button className="show-action" type={'link'} onClick={this.toggleUploadModalFun}>
                    批量导入商品
                </Button>
                <Button
                    className="show-action"
                    type={'link'}
                    onClick={() => {
                        this.handleExport(value);
                    }}
                >
                    批量导出商品
                </Button>
                {this.state.showUploadModal && <ShowProductsUploadButtonSpu {...uploadPropsObj} />}

                <ProductSelectModal
                    visible={this.state.showProductSelectModal}
                    onCancel={this.toggleProductSelectModal}
                    onOk={this.handleProductSelect}
                    type="Multi"
                    default={value}
                />
            </div>
        );
    }
}
